import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import React from "react";
import { StyledButton } from "../../../components/ListShowButton";
import DoneIcon from "@material-ui/icons/Done";
import ReplayIcon from "@material-ui/icons/Replay";

export interface IRecord {
  recordDescription: string;
  recordStatus: string;
}

interface ITableResultRouteCreation {
  records: IRecord[];
  handleRetry: any;
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
});

const TableResultRouteCreation = ({
  records,
  handleRetry,
}: ITableResultRouteCreation) => {
  const classes = useStyles();
  const renderActions = (result: IRecord, handleRetry: any) => {
    if (
      result.recordStatus === "Loading..." ||
      result.recordStatus?.includes("Retry")
    ) {
      return <CircularProgress size={30} />;
    }

    if (
      result.recordStatus?.includes("Error") &&
      result.recordStatus !== "Error, failed create route plan"
    ) {
      return (
        <StyledButton
          variant="outlined"
          startIcon={<ReplayIcon />}
          onClick={() => {
            handleRetry(result);
          }}
        >
          Retry
        </StyledButton>
      );
    }

    if (result.recordStatus?.includes("Success")) {
      return <DoneIcon />;
    }

    return <></>;
  };

  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Route Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record: IRecord, key: number) => {
            return (
              <TableRow key={`row-${key}`}>
                <TableCell>{record.recordDescription}</TableCell>
                <TableCell
                  style={{
                    color: record.recordStatus?.includes("Error")
                      ? "red"
                      : record.recordStatus?.includes("Success")
                        ? "green"
                        : "black",
                  }}
                >
                  {record.recordStatus}
                </TableCell>
                <TableCell>{renderActions(record, handleRetry)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultRouteCreation;
